// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file client/bonuses.proto (package client, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { BonusCalculationRule, BonusCancelMessageSchema, BonusHistoryMessage, BonusMessage, BonusStatus } from "../common/bonus_pb";
import { file_common_bonus } from "../common/bonus_pb";
import type { Pagination } from "../common/common_pb";
import { file_common_common } from "../common/common_pb";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file client/bonuses.proto.
 */
export const file_client_bonuses: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common_bonus, file_common_common, file_google_protobuf_empty]);

/**
 * @generated from message client.CancelMyBonusRequest
 */
export type CancelMyBonusRequest = Message<"client.CancelMyBonusRequest"> & {
  /**
   * @generated from field: optional string reason = 1;
   */
  reason?: string;
};

/**
 * Describes the message client.CancelMyBonusRequest.
 * Use `create(CancelMyBonusRequestSchema)` to create a new message.
 */
export const CancelMyBonusRequestSchema: GenMessage<CancelMyBonusRequest> = /*@__PURE__*/
  messageDesc(file_client_bonuses, 0);

/**
 * @generated from message client.GetCurrentBonusResponse
 */
export type GetCurrentBonusResponse = Message<"client.GetCurrentBonusResponse"> & {
  /**
   * @generated from field: optional common.BonusMessage data = 1;
   */
  data?: BonusMessage;
};

/**
 * Describes the message client.GetCurrentBonusResponse.
 * Use `create(GetCurrentBonusResponseSchema)` to create a new message.
 */
export const GetCurrentBonusResponseSchema: GenMessage<GetCurrentBonusResponse> = /*@__PURE__*/
  messageDesc(file_client_bonuses, 1);

/**
 * @generated from message client.ListBonusHistoryRequest
 */
export type ListBonusHistoryRequest = Message<"client.ListBonusHistoryRequest"> & {
  /**
   * @generated from field: optional common.Pagination pagination = 1;
   */
  pagination?: Pagination;

  /**
   * @generated from field: repeated common.BonusStatus status = 2;
   */
  status: BonusStatus[];
};

/**
 * Describes the message client.ListBonusHistoryRequest.
 * Use `create(ListBonusHistoryRequestSchema)` to create a new message.
 */
export const ListBonusHistoryRequestSchema: GenMessage<ListBonusHistoryRequest> = /*@__PURE__*/
  messageDesc(file_client_bonuses, 2);

/**
 * @generated from message client.ListBonusHistoryResponse
 */
export type ListBonusHistoryResponse = Message<"client.ListBonusHistoryResponse"> & {
  /**
   * @generated from field: repeated common.BonusHistoryMessage data = 1;
   */
  data: BonusHistoryMessage[];

  /**
   * @generated from field: common.Pagination pagination = 2;
   */
  pagination?: Pagination;
};

/**
 * Describes the message client.ListBonusHistoryResponse.
 * Use `create(ListBonusHistoryResponseSchema)` to create a new message.
 */
export const ListBonusHistoryResponseSchema: GenMessage<ListBonusHistoryResponse> = /*@__PURE__*/
  messageDesc(file_client_bonuses, 3);

/**
 * @generated from message client.GetPromoCodeConditionsRequest
 */
export type GetPromoCodeConditionsRequest = Message<"client.GetPromoCodeConditionsRequest"> & {
  /**
   * @generated from field: string promo_code = 1;
   */
  promoCode: string;
};

/**
 * Describes the message client.GetPromoCodeConditionsRequest.
 * Use `create(GetPromoCodeConditionsRequestSchema)` to create a new message.
 */
export const GetPromoCodeConditionsRequestSchema: GenMessage<GetPromoCodeConditionsRequest> = /*@__PURE__*/
  messageDesc(file_client_bonuses, 4);

/**
 * @generated from message client.PromoCodeConditionsMessage
 */
export type PromoCodeConditionsMessage = Message<"client.PromoCodeConditionsMessage"> & {
  /**
   * @generated from field: string min_deposit = 1;
   */
  minDeposit: string;

  /**
   * @generated from field: optional string max_bonus_amount = 2;
   */
  maxBonusAmount?: string;

  /**
   * @generated from field: string bonus_value = 3;
   */
  bonusValue: string;

  /**
   * @generated from field: string required_turnover = 4;
   */
  requiredTurnover: string;

  /**
   * @generated from field: int32 calc_rule = 5;
   */
  calcRule: number;

  /**
   * @generated from field: string wagering_multiplier = 6;
   */
  wageringMultiplier: string;

  /**
   * @generated from field: optional string expires_at = 7;
   */
  expiresAt?: string;
};

/**
 * Describes the message client.PromoCodeConditionsMessage.
 * Use `create(PromoCodeConditionsMessageSchema)` to create a new message.
 */
export const PromoCodeConditionsMessageSchema: GenMessage<PromoCodeConditionsMessage> = /*@__PURE__*/
  messageDesc(file_client_bonuses, 5);

/**
 * @generated from message client.GetPromoCodeConditionsResponse
 */
export type GetPromoCodeConditionsResponse = Message<"client.GetPromoCodeConditionsResponse"> & {
  /**
   * @generated from field: optional client.PromoCodeConditionsMessage data = 1;
   */
  data?: PromoCodeConditionsMessage;
};

/**
 * Describes the message client.GetPromoCodeConditionsResponse.
 * Use `create(GetPromoCodeConditionsResponseSchema)` to create a new message.
 */
export const GetPromoCodeConditionsResponseSchema: GenMessage<GetPromoCodeConditionsResponse> = /*@__PURE__*/
  messageDesc(file_client_bonuses, 6);

/**
 * @generated from message client.CheckPromoCodeRequest
 */
export type CheckPromoCodeRequest = Message<"client.CheckPromoCodeRequest"> & {
  /**
   * @generated from field: string promo_code = 1;
   */
  promoCode: string;
};

/**
 * Describes the message client.CheckPromoCodeRequest.
 * Use `create(CheckPromoCodeRequestSchema)` to create a new message.
 */
export const CheckPromoCodeRequestSchema: GenMessage<CheckPromoCodeRequest> = /*@__PURE__*/
  messageDesc(file_client_bonuses, 7);

/**
 * @generated from message client.PromoCodeCheckMessage
 */
export type PromoCodeCheckMessage = Message<"client.PromoCodeCheckMessage"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: common.BonusCalculationRule calc_rule = 2;
   */
  calcRule: BonusCalculationRule;

  /**
   * @generated from field: string calc_value = 3;
   */
  calcValue: string;

  /**
   * @generated from field: string min_deposit = 4;
   */
  minDeposit: string;

  /**
   * @generated from field: string estimated_bonus_amount = 5;
   */
  estimatedBonusAmount: string;

  /**
   * @generated from field: string estimated_turnover = 6;
   */
  estimatedTurnover: string;

  /**
   * @generated from field: string wagering_multiplier = 7;
   */
  wageringMultiplier: string;

  /**
   * @generated from field: bool is_minimum_estimate = 8;
   */
  isMinimumEstimate: boolean;

  /**
   * Promo code's end_at, when set. Only populated for the available-codes list; the
   * single-code check card doesn't render an expiry so it's left unset there.
   *
   * @generated from field: optional string valid_until = 9;
   */
  validUntil?: string;
};

/**
 * Describes the message client.PromoCodeCheckMessage.
 * Use `create(PromoCodeCheckMessageSchema)` to create a new message.
 */
export const PromoCodeCheckMessageSchema: GenMessage<PromoCodeCheckMessage> = /*@__PURE__*/
  messageDesc(file_client_bonuses, 8);

/**
 * @generated from message client.CheckPromoCodeResponse
 */
export type CheckPromoCodeResponse = Message<"client.CheckPromoCodeResponse"> & {
  /**
   * @generated from field: bool available = 1;
   */
  available: boolean;

  /**
   * @generated from field: optional client.PromoCodeRejectReason reason = 2;
   */
  reason?: PromoCodeRejectReason;

  /**
   * @generated from field: optional client.PromoCodeCheckMessage conditions = 3;
   */
  conditions?: PromoCodeCheckMessage;
};

/**
 * Describes the message client.CheckPromoCodeResponse.
 * Use `create(CheckPromoCodeResponseSchema)` to create a new message.
 */
export const CheckPromoCodeResponseSchema: GenMessage<CheckPromoCodeResponse> = /*@__PURE__*/
  messageDesc(file_client_bonuses, 9);

/**
 * Promo codes the admin has flagged as publicly listed AND that the authenticated
 * user can actually redeem right now (mirrors CheckPromoCode's per-user checks).
 *
 * @generated from message client.ListAvailablePromoCodesResponse
 */
export type ListAvailablePromoCodesResponse = Message<"client.ListAvailablePromoCodesResponse"> & {
  /**
   * @generated from field: repeated client.PromoCodeCheckMessage data = 1;
   */
  data: PromoCodeCheckMessage[];
};

/**
 * Describes the message client.ListAvailablePromoCodesResponse.
 * Use `create(ListAvailablePromoCodesResponseSchema)` to create a new message.
 */
export const ListAvailablePromoCodesResponseSchema: GenMessage<ListAvailablePromoCodesResponse> = /*@__PURE__*/
  messageDesc(file_client_bonuses, 10);

/**
 * @generated from enum client.PromoCodeRejectReason
 */
export enum PromoCodeRejectReason {
  /**
   * @generated from enum value: PROMO_CODE_REJECT_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROMO_CODE_REJECT_REASON_NOT_FOUND = 1;
   */
  NOT_FOUND = 1,

  /**
   * @generated from enum value: PROMO_CODE_REJECT_REASON_EXPIRED = 2;
   */
  EXPIRED = 2,

  /**
   * @generated from enum value: PROMO_CODE_REJECT_REASON_LIMIT_REACHED = 3;
   */
  LIMIT_REACHED = 3,

  /**
   * @generated from enum value: PROMO_CODE_REJECT_REASON_ALREADY_USED = 4;
   */
  ALREADY_USED = 4,

  /**
   * @generated from enum value: PROMO_CODE_REJECT_REASON_FIRST_DEPOSIT_ONLY = 5;
   */
  FIRST_DEPOSIT_ONLY = 5,
}

/**
 * Describes the enum client.PromoCodeRejectReason.
 */
export const PromoCodeRejectReasonSchema: GenEnum<PromoCodeRejectReason> = /*@__PURE__*/
  enumDesc(file_client_bonuses, 0);

/**
 * @generated from service client.BonusesRPCService
 */
export const BonusesRPCService: GenService<{
  /**
   * @generated from rpc client.BonusesRPCService.GetCurrentBonus
   */
  getCurrentBonus: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof GetCurrentBonusResponseSchema;
  },
  /**
   * @generated from rpc client.BonusesRPCService.ListBonusHistory
   */
  listBonusHistory: {
    methodKind: "unary";
    input: typeof ListBonusHistoryRequestSchema;
    output: typeof ListBonusHistoryResponseSchema;
  },
  /**
   * @generated from rpc client.BonusesRPCService.GetPromoCodeConditions
   */
  getPromoCodeConditions: {
    methodKind: "unary";
    input: typeof GetPromoCodeConditionsRequestSchema;
    output: typeof GetPromoCodeConditionsResponseSchema;
  },
  /**
   * @generated from rpc client.BonusesRPCService.CheckPromoCode
   */
  checkPromoCode: {
    methodKind: "unary";
    input: typeof CheckPromoCodeRequestSchema;
    output: typeof CheckPromoCodeResponseSchema;
  },
  /**
   * @generated from rpc client.BonusesRPCService.ListAvailablePromoCodes
   */
  listAvailablePromoCodes: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListAvailablePromoCodesResponseSchema;
  },
  /**
   * @generated from rpc client.BonusesRPCService.CancelMyBonus
   */
  cancelMyBonus: {
    methodKind: "unary";
    input: typeof CancelMyBonusRequestSchema;
    output: typeof BonusCancelMessageSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_client_bonuses, 0);

